<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Fulfill All Pledges</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Fulfill all pledges for all donors</div>
        </div>
    </div>
</div>

<div [formGroup]="form" class="modal-body custom-material-form overflow-auto" style="max-height: 50vh;"> 
    @for(donor of donorReport; track donor.id) {
        <div class="row fundraiser-row mb-4" [id]="donor.id">
            <div class="col-6 d-flex flex-column justify-content-start body-2--weight-medium">
                <div>{{donor.displayName}}</div>
                <div class="d-flex align-items-center">
                    <div>{{donor.userInfo.name}} / {{donor.userInfo.email}}</div>
                </div>
            </div>
            <div class="col-6">
                <mdb-form-control class="form-fill form-outline mb-0">
                    <app-mdbp-input mdbInput [formControlName]="donor.id" label='Enter milestone count' type="number" [showMaxLength]="false"></app-mdbp-input>
                    @if(form.controls[donor.id].invalid && form.controls[donor.id].touched) {
                        <span class="form-fill-error ml-0">{{eventCountErrorText}}</span>
                    }
                </mdb-form-control> 
            </div>
        </div>

        <div class="row body-2--weight-medium mb-2">
            <div class="col-4">Donor</div>
            <div class="col-4">Pledge Per Milestone</div>
            <div class="col-4">Charge Amount</div>
        </div>

        @for(pledge of donor.pledges; track pledge.id) {
            <div class="donor-pledges-item">
                <div class="row body-2 my-2">
                    <div class="col-4" [innerHTML]="pledge.donorInfo.name"></div>
                    <div class="col-4"> {{pledge.amount | currency:'USD':'symbol-narrow':'1.0-0'}} </div>
                    <div class="col-4"> {{pledge.amountCharged | currency:'USD':'symbol-narrow':'1.0-0'}} </div>
                </div>
                <div class="divider my-2"></div>
            </div>
        }
    } 
    @empty {
        <div class="body-2">No pledges found</div>
    }
</div>

<div class="modal-footer paybee-modal-footer">
    <a (click)="close()" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
    <a (click)="onFulfillBulkPledges()" [class.disabled]="btnDisabled" class="btn btn-sm modal-confirm-button waves-effect waves-light">Fulfill</a>
</div>